export const JWT_RESPONSE_HEADER = 'token';








































































































































































































































































































































































































































































































































































